import * as CategoryData from './data/categories.data.js';
import * as AffinityCategoriesData from './data/affinityCategories.data.js';
import type { TopicAffinityName } from '@myredhat/elements/lib/affinitiesService';

// https://docs.google.com/spreadsheets/d/1Q4w0pGHt_gzSSAp0yG6x2_qmZ9VmJ9gu5VCVV29_TGY/edit?gid=0#gid=0
export const { CATEGORIES } = CategoryData;

export type CategoryName = (keyof typeof CATEGORIES);

export type CategoryList = {
  [K in keyof typeof CATEGORIES]: [K, typeof CATEGORIES[K]];
}[keyof typeof CATEGORIES];

export const CATEGORIES_TOP_5: CategoryName[] = [
  'Edge',
  'DevOps',
  'Infrastructure',
  'Automation',
  'Cloud',
];

type AffinityCategories = Partial<Record<TopicAffinityName, CategoryName>>

export const AFFINITY_CATEGORY_MAP = {} as AffinityCategories;

// Convert nested object to key value map of affinityName to category
for (const [key, value] of Object.entries(AffinityCategoriesData.AFFINITY_CATEGORIES)) {
  AFFINITY_CATEGORY_MAP[key as TopicAffinityName] = value.Category;
}
